import React, { Component } from "react";
import classNames from "classnames";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import "./SingleCollection.css";

class SingleCollection extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeCollection: props.activeCollection,
      translateXValue: 0,
      currentImageStep: 0,
      killAnimation: false,
    };

    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  componentDidMount() {
    const { data, activeCollection } = this.props;
    if (data[activeCollection]) {
      const numberOfLandscapeImages = document.querySelectorAll(
        ".SingleCollection-image--ls"
      ).length;
      this.setState({
        numberOfLandscapeImages,
        activeCollection: activeCollection,
        containerWidth:
          data[activeCollection].photos.length * 50 +
          numberOfLandscapeImages * 50,
      });
    }

    document.addEventListener("keydown", this.handleKeyDown);
  }

  handleKeyDown(e) {
    const LEFT_ARROW = e.keyCode === 37;
    const RIGHT_ARROW = e.keyCode === 39;
    if (LEFT_ARROW) {
      this.switchImages("prev");
    } else if (RIGHT_ARROW) {
      this.switchImages("next");
    }
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
  }

  switchCollections(direction) {
    const { activeCollection } = this.state;
    const { data } = this.props;
    if (direction === "next") {
      this.setState({
        activeCollection:
          activeCollection === data.length - 1 ? 0 : activeCollection + 1,
      });
    } else {
      this.setState({
        activeCollection:
          activeCollection === 0 ? data.length - 1 : activeCollection - 1,
      });
    }
    this.setState({
      currentImageStep: 0,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.activeCollection !== this.props.activeCollection) {
      this.setState({
        activeCollection: this.props.activeCollection,
      });
    }

    if (prevState.activeCollection !== this.state.activeCollection) {
      const numberOfLandscapeImages = this.props.data[
        this.state.activeCollection
      ].photos.filter((i) => i.orientation === "landscape").length;
      this.setState({
        containerWidth:
          this.props.data[this.state.activeCollection].photos.length * 50 +
          numberOfLandscapeImages * 50,
      });
    }
  }

  switchImages(direction) {
    const { currentImageStep, containerWidth } = this.state;
    const maxSteps = Math.floor(containerWidth / 110);
    if (direction === "next") {
      if (currentImageStep === maxSteps) {
        this.setState({
          killAnimation: true,
        });
      } else {
        this.setState({
          killAnimation: false,
        });
      }
      this.setState({
        currentImageStep:
          currentImageStep === maxSteps ? 0 : currentImageStep + 1,
      });
    } else {
      if (currentImageStep === 0) {
        this.setState({
          killAnimation: true,
        });
      } else {
        this.setState({
          killAnimation: false,
        });
      }
      this.setState({
        currentImageStep:
          currentImageStep === 0 ? maxSteps : currentImageStep - 1,
      });
    }
  }

  handleTouchStart(event) {
    this.x = event.touches[0].clientX;
    this.y = event.touches[0].clientY;
  }

  handleTouchMove(event) {
    this.xM = event.changedTouches[0].clientX;
    this.yM = event.changedTouches[0].clientY;
    const xDiff = this.xM - this.x;
    const yDiff = this.yM - this.y;
    if (Math.abs(xDiff) > Math.abs(yDiff)) {
      if (xDiff > 0) {
        this.switchImages("prev");
      } else {
        this.switchImages("next");
      }
    }
    this.x = null;
    this.y = null;
  }

  render() {
    const {
      activeCollection,
      containerWidth,
      currentImageStep,
      killAnimation,
    } = this.state;
    const { data, language } = this.props;
    const translateXValue = (100 / (containerWidth / 100)) * currentImageStep;

    const imgwrapperClasses = classNames(
      "SingleCollection-images",
      killAnimation && "SingleCollection-images--killed"
    );

    return (
      <div className="SingleCollection">
        <div className="SingleCollection-text">
          {data[activeCollection].text[language]}
        </div>
        <div className="SingleCollection-content">
          <button
            onClick={() => this.switchCollections("next")}
            className="NextButton"
          >
            <div className="Button-div">
              <svg width="24" height="24" fillRule="evenodd" clipRule="evenodd">
                <path d="M21.883 12l-7.527 6.235.644.765 9-7.521-9-7.479-.645.764 7.529 6.236h-21.884v1h21.883z" />
              </svg>
            </div>
          </button>
          <h4 className="SingleCollection-title">
            {data[activeCollection].title[language]}
          </h4>
          <div className="SingleCollectionBorder" />
          <p className="SingleCollection-desc">
            {data[activeCollection].description[language]}
          </p>
          <button
            onClick={() => this.switchCollections("prev")}
            className="PrevButton"
          >
            <div className="Button-div">
              <svg width="24" height="24" fillRule="evenodd" clipRule="evenodd">
                <path d="M2.117 12l7.527 6.235-.644.765-9-7.521 9-7.479.645.764-7.529 6.236h21.884v1h-21.883z" />
              </svg>
            </div>
          </button>
          <div className="ArrowsMobile2">
            <div className="ArrowPrevMobile">
              <button
                className="PrevButton"
                onClick={() => this.switchCollections("prev")}
              >
                <svg
                  className="SvgPrev"
                  width="24"
                  height="24"
                  xmlns="http://www.w3.org/2000/svg"
                  fillRule="evenodd"
                  clipRule="evenodd"
                >
                  <path d="M2.117 12l7.527 6.235-.644.765-9-7.521 9-7.479.645.764-7.529 6.236h21.884v1h-21.883z" />
                </svg>
              </button>
            </div>
            <div className="ArrowNextMobile">
              <button
                className="NextButton"
                onClick={() => this.switchCollections("next")}
              >
                <svg
                  className="SvgNext"
                  width="24"
                  height="24"
                  xmlns="http://www.w3.org/2000/svg"
                  fillRule="evenodd"
                  clipRule="evenodd"
                >
                  <path d="M21.883 12l-7.527 6.235.644.765 9-7.521-9-7.479-.645.764 7.529 6.236h-21.884v1h21.883z" />
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div
          className="ImagesWrapper"
          onTouchStart={(event) => this.handleTouchStart(event)}
          onTouchEnd={(event) => this.handleTouchMove(event)}
        >
          <button
            onClick={() => this.switchImages("prev")}
            className="SingleCollection-Button"
          >
            <div className="Button-div">
              <svg
                className="SvgPrev"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z" />
              </svg>
            </div>
          </button>
          <div className="SingleCollection-RelativeDiv">
            <div
              className={imgwrapperClasses}
              style={{
                width: `${containerWidth}%`,
                transform: `translateX(-${translateXValue}%)`,
              }}
            >
              {data[activeCollection].photos.map((item, index) => {
                const imageClasses = classNames(
                  "SingleCollection-image",
                  item.orientation === "landscape" &&
                    "SingleCollection-image--ls"
                );
                return (
                  <div
                    className={imageClasses}
                    key={index}
                    style={{ backgroundImage: `url(${item.image})` }}
                  />
                );
              })}
            </div>
          </div>
          <button
            onClick={() => this.switchImages("next")}
            className="SingleCollection-Button"
          >
            <div className="Button-div">
              <svg
                className="SvgNext"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path d="M7.33 24l-2.83-2.829 9.339-9.175-9.339-9.167 2.83-2.829 12.17 11.996z" />
              </svg>
            </div>
          </button>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    language: state.language,
  };
}

export default withRouter(connect(mapStateToProps)(SingleCollection));



// WEBPACK FOOTER //
// ./src/components/SingleCollection/index.js